import React from 'react';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import { useSnackbar } from 'notistack';
import ListItemText from '@mui/material/ListItemText';
import Select from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';
import TextField from '@mui/material/TextField';
import Fab from '@mui/material/Fab';
import SearchIcon from '@mui/icons-material/Search';
import dayjs from 'dayjs';
import TokenService from '../../services/TokenService'
import LoadingIndicator from '../LoadingIndicator';
import OrderListTable from '../Pickups/OrderListTable.jsx';
import AdminOrderView from '../Pickups/AdminOrderView.jsx';
import Slide from '@mui/material/Slide';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

const statuses = [
    'Any',
    'Unscheduled',
    'Scheduled',
    'Paid',
    'Cancelled',
    'Expired',
];

function Orders(props) {

    const [selectedStatuses, setSelectedStatuses] = React.useState(['Any']);
    const [selectedDateRange, setSelectedDateRange] = React.useState('');
    const [selectedConfirmationNumber, setSelectedConfirmationNumber] = React.useState(props.navigationData == null ? '' : props.navigationData);
    const [isLoading, setIsLoading] = React.useState(false);
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();

    const [orders, setOrders] = React.useState(null);
    const [selectedOrder, setSelectedOrder] = React.useState(null);

    React.useEffect(() => {
        if (props.navigationData != null) {
            adminOrderSearch();
        }
    }, []);


    function handleStatusChanged(event) {
        let values = event.target.value;
        if (values.length == 0) {
            values = ['Any']
        }
        else if (values.length > 1 && values[values.length - 1] === 'Any') {
            values = ['Any']; // user just selected the Any option
        }
        else if (values.length > 1) {
            values = values.filter(x => x !== 'Any');
        }

        setSelectedStatuses(
            // On autofill we get a stringified value.
            typeof values === 'string' ? values.split(',') : values,
        );
    }

    function handleDateRangeChanged(event) {
        setSelectedDateRange(event.target.value);
    }

    function handleConfirmationNumberChanged(e) {
        const re = /^[0-9\b]+$/;

        // if value is not blank, then test the regex

        if (e.target.value === '' || re.test(e.target.value)) {
            setSelectedConfirmationNumber(e.target.value)
        }
    }

    function adminOrderSearch() {
        setIsLoading(true);
        let startRange = '';
        let endRange = '';

        if (selectedDateRange === '') {
            startRange = '2000-01-01';
            endRange = '9999-12-01';
        }
        else if (selectedDateRange == 'Today') {
            startRange = dayjs().format('MM/DD/YYYY');
            endRange = dayjs().add(1, 'day').format('MM/DD/YYYY');
        }
        else if (selectedDateRange == 'Yesterday') {
            startRange = dayjs().add(-1, 'day').format('MM/DD/YYYY');
            endRange = dayjs().format('MM/DD/YYYY');
        }
        else if (selectedDateRange == 'Last 7') {
            startRange = dayjs().add(-7, 'day').format('MM/DD/YYYY');
            endRange = dayjs().add(1, 'day').format('MM/DD/YYYY'); // include end of today
        }
        else if (selectedDateRange == 'Last 30') {
            startRange = dayjs().add(-30, 'day').format('MM/DD/YYYY');
            endRange = dayjs().add(1, 'day').format('MM/DD/YYYY'); // include end of today
        }
        else if (selectedDateRange == 'This Month') {
            startRange = dayjs().startOf("month").format('MM/DD/YYYY');
            endRange = dayjs().add(1, 'day').format('MM/DD/YYYY'); // include end of today
        }
        else if (selectedDateRange == 'Last Month') {
            startRange = dayjs().startOf("month").add(-1, 'month').format('MM/DD/YYYY');
            endRange = startRange.endOf("month").add(1, 'day').format('MM/DD/YYYY'); // midnight on first day of next month
        }


        let postData = {
            scheduled: selectedStatuses.indexOf('Scheduled') > -1 || selectedStatuses.indexOf('Any') > -1 ? true : false,
            unscheduled: selectedStatuses.indexOf('Unscheduled') > -1 || selectedStatuses.indexOf('Any') > -1 ? true : false,
            paid: selectedStatuses.indexOf('Paid') > -1 || selectedStatuses.indexOf('Any') > -1 ? true : false,
            cancelled: selectedStatuses.indexOf('Cancelled') > -1 || selectedStatuses.indexOf('Any') > -1 ? true : false,
            expired: selectedStatuses.indexOf('Expired') > -1 || selectedStatuses.indexOf('Any') > -1 ? true : false,
            minQuantity: 0,
            requestID: isNaN(selectedConfirmationNumber) || selectedConfirmationNumber == '' ? 0 : selectedConfirmationNumber,
            startRange: startRange,
            endRange: endRange
        }

        TokenService.post(postData, 'Admin_OrderSearch')

            .then((response) => {
                setIsLoading(false);
                response = response[Object.keys(response)[0]];
                if (response.Result == "SUCCESS") {
                    let jsonData = JSON.parse(response.JsonData);
                    setOrders(jsonData);
                }
                else {
                    enqueueSnackbar(response.Message, {
                        variant: 'error',
                    });
                }

            })
            .catch((response) => {
                enqueueSnackbar('Oops, something went wrong', {
                    variant: 'error',
                });
                setIsLoading(false);
            });

    }

    function showLoadingIndicator() {
        return <LoadingIndicator Message={'Loading' } />
    }

    function handleCloseDetail() {
        setSelectedOrder(null);
    }

    function handleOrderSelected(order) {
        setSelectedOrder(order);
    }

    function buildOrders() {
        if (orders === null) {
            return null;
        }

        if (orders.length == 0) {
            return <div>
                No Orders
            </div>
        }

        return (
            <div>
                <OrderListTable Orders={orders} loggedInUser={props.loggedInUser} Section='Admin' OrderSelected={handleOrderSelected} />
            </div>

        )
    }

    return (
        <div style={{marginBottom:'200px'} }>
            {isLoading ?
                showLoadingIndicator()
                :
                <>
                    <Slide direction="right" in={selectedOrder === null} mountOnEnter unmountOnExit >
                        <div>
                            <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                                <div style={{ alignSelf: 'flex-start' }}>
                                    <FormControl sx={{ m: 1, width: 120 }}>
                                        <InputLabel id="selectedStatusLabel">Status</InputLabel>
                                        <Select
                                            labelId="selectedStatusLabel"

                                            multiple
                                            value={selectedStatuses}
                                            onChange={handleStatusChanged}
                                            input={<OutlinedInput label="Status" />}
                                            renderValue={(selected) => selected.join(', ')}
                                            MenuProps={MenuProps}
                                        >
                                            {statuses.map((status) => (
                                                <MenuItem key={status} value={status}>
                                                    <Checkbox checked={selectedStatuses.indexOf(status) > -1} />
                                                    <ListItemText primary={status} />
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </div>
                                <div style={{ alignSelf: 'flex-start', paddingTop: '7px' }}>
                                    <FormControl fullWidth style={{ minWidth: '100px' }}>
                                        <InputLabel id="selectedDateRangeLabel">Date</InputLabel>
                                        <Select
                                            labelId="selectedDateRangeLabel"

                                            value={selectedDateRange}
                                            label="Date"
                                            onChange={handleDateRangeChanged}
                                        >
                                            <MenuItem value={''}>Any</MenuItem>
                                            <MenuItem value={'Today'}>Today</MenuItem>
                                            <MenuItem value={'Yesterday'}>Yesterday</MenuItem>
                                            <MenuItem value={'Last 7'}>Last 7 days</MenuItem>
                                            <MenuItem value={'Last 30'}>Last 30 days</MenuItem>
                                            <MenuItem value={'This Month'}>This Month</MenuItem>
                                            <MenuItem value={'Last Month'}>Last Month</MenuItem>
                                            {/*  <MenuItem value={'Custom'}>Custom</MenuItem>*/}
                                        </Select>
                                    </FormControl>
                                </div>
                                <div style={{ alignSelf: 'flex-start', paddingTop: '7px', marginLeft: '7px' }}>
                                    <TextField label='Conf#' variant='outlined' value={selectedConfirmationNumber} style={{ width: '100px' }} onChange={handleConfirmationNumberChanged} />
                                </div>
                                <div style={{ alignSelf: 'flex-start', paddingTop: '7px', marginLeft: '7px' }}>
                                    <Fab onClick={adminOrderSearch} sx={{ backgroundColor: 'var(--sipzee-green)' }}><SearchIcon /></Fab>
                                </div>
                            </div >
                            {
                                buildOrders()
                            }
                        </div>
                    </Slide>

                    <Slide direction="left" in={selectedOrder !== null} mountOnEnter unmountOnExit >
                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <Card sx={{ minWidth: 300, maxWidth: 600, width: '100%', alignSelf: 'center', margin: '0px', padding: '0px' }}>

                                <CardContent style={{ padding: '5px' }}>
                                    <div>
                                        <AdminOrderView
                                            order={selectedOrder}
                                            onBack={() => setSelectedOrder(null)}
                                            loggedInUser={props.loggedInUser}
                                        />
                                    </div>
                                </CardContent>
                            </Card>
                        </div>
                    </Slide>
                </>
            }
            </div>
        )
} export default Orders;